import {iEnrollment} from "./iEnrollment";

export const newEnrollment: iEnrollment = {
    id: 0,
    PaymentCard: 0,
    Date: (new Date()).toISOString(),
    ExpireDate: (new Date()).toISOString(),
    dhDate: (new Date()).toISOString(),
    dhExpireDate: (new Date()).toISOString(),
    EnrollmentType: 1,
    Status: 0,
    EnrollmentInLevel_id: 0,
    UsuarioFezMatricula: 0,
    NumberOfInstallments: 0,
    TotalAmount: 0,
    Comment: "",
    SituacaoSecretaria: 1,
    UsuarioFezRevisao: 0,
    dhVecto1aParcela: (new Date()).toISOString(),
    ValorParcela: 0,
    Level_id: 0,
}